import { render, staticRenderFns } from "./employeeTagsDialog.vue?vue&type=template&id=65546746"
import script from "./employeeTagsDialog.vue?vue&type=script&lang=js"
export * from "./employeeTagsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports